import React from 'react';
import '../../components/DBOSHomepage.css';
import '../SmartWeb.css';
import './Legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="container">
          <a href="/" className="logo">
            <span className="logo-text shimmering">DBOS.world</span>
          </a>
        </div>
      </header>
      <main className="legal-content">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p className="version-info">V1.0 | 03/03/2026</p>
          
          <section className="legal-section">
            <h2>1. Provider</h2>
            <p className="provider-info">
              <strong>DBOS</strong><br/>
              (operating under Smart Trades Training, CRO No. 778363)<br/>
              Arvagh, Co. Cavan, Ireland
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Scope of Services</h2>
            <p>DBOS provides digital infrastructure, consulting, system implementation, automation, hosting coordination, and related services as defined in the individual proposal, invoice, or order confirmation. All services are delivered within the DBOS framework.</p>
            <p>Custom development outside DBOS standards is excluded unless explicitly agreed in writing.</p>
          </section>

          <section className="legal-section">
            <h2>3. Contract Formation</h2>
            <p>This Agreement becomes legally binding when:</p>
            <ul>
              <li>Signed physically, OR</li>
              <li>Accepted electronically via DBOS platform, OR</li>
              <li>Payment is made against an issued invoice</li>
            </ul>
            
            <h3>3a. Business Clients (B2B)</h3>
            <p>Clients acting in the course of a trade or profession confirm their business status at acceptance. Consumer withdrawal rights do not apply.</p>
            
            <h3>3b. Consumer & Sole Trader Clients</h3>
            <p>Consumers have the right to withdraw within fourteen (14) calendar days of acceptance. To withdraw, contact: <a href="mailto:support@dbos.world">support@dbos.world</a></p>
          </section>

          <section className="legal-section">
            <h2>4. Fees & Payment</h2>
            <p>All fees are defined in the respective offer or invoice. Payments must be made within stated payment terms. Late payments may result in suspension of services.</p>
            <p>DBOS reserves the right to adjust fees with ninety (90) calendar days written notice.</p>
          </section>

          <section className="legal-section">
            <h2>5. Intellectual Property</h2>
            <p>All DBOS systems, software, automation structures, and frameworks remain the exclusive property of DBOS. Clients receive a non-exclusive right to use delivered services during the contractual period.</p>
          </section>

          <section className="legal-section">
            <h2>6. Limitation of Liability</h2>
            <p>Liability is limited to the total amount paid by the client within the previous 12 months. DBOS is not liable for indirect damages, loss of profits, business interruption, or third-party service failures.</p>
          </section>

          <section className="legal-section">
            <h2>7. Termination</h2>
            <p>Either party may terminate with minimum thirty (30) calendar days written notice to <a href="mailto:support@dbos.world">support@dbos.world</a>, unless material breach occurs.</p>
          </section>

          <section className="legal-section">
            <h2>8. AI Systems &amp; the EU AI Act</h2>
            <p>DBOS uses artificial intelligence to support certain services (for example, automatic classification and organisation of files). All AI features operate under our core principle: AI describes, the operator decides - AI provides suggestions, classifications, and insights, but does not make unsupervised decisions on the client's behalf.</p>
            <p>DBOS is designed and operated in alignment with the EU Artificial Intelligence Act (Regulation (EU) 2024/1689), including the transparency obligations that apply from 2 August 2026. Where a service uses AI to interact with a user, or to generate or manipulate content, this is disclosed to the client.</p>
            <p>DBOS does not use AI to make legal or similarly significant decisions about clients without human review.</p>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>These Terms are governed by the laws of Ireland.</p>
          </section>

          <div className="legal-footer">
            <p><a href="/legal/privacy">Privacy Policy</a> | <a href="/legal/cookies">Cookies</a> | <a href="/legal/dpa">DPA</a></p>
            <a href="/" className="btn-back">← Back to Home</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Terms;
